module.exports = __webpack_public_path__ + "static/media/service-snow.ebf0e03b.jpg";